import httpService from "services/api.service";

const BASE_URL = "/stock_loading";

export const getLoadingStock = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.message;
  }
};

export const approvalLoadingUnloading = async (payload, isLoadingStock) => {
  try {
    const res = await httpService.post(
      isLoadingStock ? "/approve_loading" : "/approve_unloading",
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return res;
  } catch (error) {
    throw error.message;
  }
};
